<template>
  <div>
    <v-data-table class="invoicingTable vtable-scroll-x" hide-default-footer show-expand single-expand
      mobile-breakpoint="0" :expanded.sync="expanded" :items-per-page="invoicingFilter.size" :footer-props="{
        'items-per-page-text': 'Linhas por página',
        'first-icon': 'mdi-chevron-up',
        'page-text': '',
        'items-per-page-options': [10, 25, 50, 100],
      }" :headers="headers" :height="invoicingTableHeight" :items="xippPlatformInvoices" :page="invoicingFilter.page"
      :server-items-length="invoicesTotalElements">
      <!-- Cabeçalho -->
      <template v-for="header in defaultHeaderColumns" v-slot:[`header.${header.id}`]="{ }">
        <HeaderCell :key="header.id" :id="header.id" :title="header.title" :headerClass="headerFirstLineClass"
          :headerStyle="headerFirstLine.style" />
      </template>
  
      <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
        <v-icon v-if="canExpand(item)" @click.stop="expand(!isExpanded)" class="mr-2">
          {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </template>
  
      <!-- Tabela -->
      <template v-for="column in defaultStyleColumns" v-slot:[`item.${column}`]="{ item }">
        <Cell :key="column" :id="column" :content="item[column]" :cellClass="column" />
      </template>
  
      <template v-slot:[`item.isIntegrator`]="{ item }">
        <v-checkbox disabled v-model="item.isIntegrator" :value=item.isIntegrator></v-checkbox>
      </template>
  
      <template v-slot:[`item.downloads`]="{ item }">
        <span>{{
          item.downloads && item.downloads.length
            ? item.downloads.length > 1
              ? `${item.downloads.length}
          Arquivos`
              : `${item.downloads.length} Arquivo`
            : "0 Arquivos"
        }}</span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td v-for="header in headers" :key="header.value" class="py-2" :class="header.cellClass">
          <div v-if="header.value === 'downloads'">
            <div v-if="item.downloads && item.downloads.length">
              <v-list dense class="py-0">
                <v-list-item v-for="att in item.downloads" :key="att.fileName" class="px-0">
                  <v-list-item-content class="py-1">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-on="on" v-bind="attrs" class="d-inline-block fileToDownload"
                          @click="downloadFile(att.fileId)">
                          {{ att.fileName }}
                        </span>
                      </template>
                      <span>Último download:
                        {{
                          `${att.userName}
                        ${formatter.formatDateTimeZoneWithHours(att.downloadDate)}` || ""
                        }}</span>
                    </v-tooltip>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            <div v-else class="caption grey--text">Sem anexos</div>
          </div>
        </td>
      </template>
  
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn color="primary" dark icon @click="openHistoryModal(item.id)">
          <v-icon> mdi mdi-clipboard-text-clock-outline </v-icon>
        </v-btn>
      </template>
  
      <template v-slot:footer="{ props }">
        <v-container fluid class="px-0 pt-0">
          <v-divider />
          <v-row justify="end" class="d-flex flex-row align-center fill-height px-8 pt-2" style="height: 70px">
            <div class="d-flex flex-row align-center fill-height">
              <span style="margin-right: 50px" :class="labelFooter.class" :style="labelFooter.style"> Linhas por página
              </span>
  
              <v-select :value="invoicingFilter.size" :items="props.itemsPerPageOptions" hide-details dense
                class="footerSelectItemsPerPage primary--text mt-0" color="primary" :style="selectFooter.style"
                append-icon="mdi-chevron-down" @change="setSize" />
            </div>
  
            <span v-if="invoicesTotalElements" :class="labelFooter.class" :style="labelFooter.style">
              {{ rangePagination }}
            </span>
  
            <v-btn icon :disabled="invoicingFilter.page === 0"
              @click="setInvoicingFilter({ page: invoicingFilter.page - 1 })">
              <v-icon size="24" color="primary"> mdi-chevron-left </v-icon>
            </v-btn>
  
            <v-btn icon
              :disabled="(invoicingFilter.page + 1) * props.pagination.itemsPerPage >= props.pagination.itemsLength"
              @click="setInvoicingFilter({ page: invoicingFilter.page + 1 })">
              <v-icon size="24" color="primary"> mdi-chevron-right </v-icon>
            </v-btn>
          </v-row>
        </v-container>
      </template>
    </v-data-table>
    <DownloadHistoryModal :invoicingId="selectedInvoicingId" />
  </div>
</template>

<script>
import TodoListActions from "../../../TodoList/TodoListActions.vue";
import HeaderCell from "../HeaderCell.vue";
import Cell from "../Cell.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

import MovementRecordsMixin from "@/shared/mixins/movementRecords/movementRecordsMixin";
import InsuranceCarriersMixin from "@/shared/mixins/sdi/insuranceCarriersMixin";
import FinancialGroupsMixin from "@/shared/mixins/sdi/financialGroupsMixin";
import InvoicingMixin from "@/shared/mixins/invoicing/invoicingMixin";
import ContractsMixin from "@/shared/mixins/sdi/contractsMixin";
import InvoicingRules from "../../rules/invoicingRules.js";
import DownloadHistoryModal from "./DownloadHistoryModal.vue";

import Formatters from "@/shared/formatters/formatters";

export default {
  name: "InvoicingXippPlatformTable",

  components: {
    DownloadHistoryModal,
    TodoListActions,
    HeaderCell,
    Cell,
  },

  data: () => ({
    formatter: null,
    expanded: [],
    defaultHeaderColumns: [
      { id: "financialGroup", title: "Grupo financeiro" },
      { id: "contract", title: "Contrato" },
      { id: "subcontract", title: "Subcontrato" },
      { id: "carrierName", title: "Operadora" },
      { id: "competencyDate", title: "Competência" },
      { id: "invoiceType", title: "Tipo de Fatura" },
      { id: "numberLives", title: "Número de vidas" },
      { id: "copayValue", title: "Valor Copay" },
      { id: "premiumValue", title: "Prêmio Valor" },
      { id: "iofValue", title: "Valor IOF" },
      { id: "replaceFeeValue", title: "2ª via de catão" },
      { id: "settlementValue", title: "Acertos" },
      { id: "otherAmountsValue", title: "Outros valores" },
      { id: "bankSlipValue", title: "Valor Total do Boleto Bancário" },
      { id: "isIntegrator", title: "Integradora" },
      { id: "downloads", title: "Anexos" },
      { id: "status", title: "Status" },
      { id: "actions", title: "Histórico de downloads" },
    ],
    selectedInvoicingId: null,
  }),

  mixins: [InsuranceCarriersMixin, MovementRecordsMixin, FinancialGroupsMixin, ContractsMixin, InvoicingRules, InvoicingMixin],

  methods: {
    ...mapActions({
      setInvoicingFilter: "invoicing/setInvoicingFilter",
    }),

    ...mapMutations({
      setShowDownloadHistoryModal: "invoicing/setShowDownloadHistoryModal",
    }),

    canExpand(item) {
      return item.downloads && item.downloads.length > 0;
    },
    onRowClick(item) {
      if (!this.canExpand(item)) return;
      const idx = this.expanded.findIndex((e) => e === item || e.id === item.id);
      if (idx > -1) {
        this.expanded.splice(idx, 1);
      } else {
        this.expanded.push(item);
      }
    },

    setSize(size) {
      this.setInvoicingFilter({ size: size, page: 0 });
    },

    openHistoryModal(invoicingId) {
      this.selectedInvoicingId = invoicingId
      this.setShowDownloadHistoryModal(true);
    },
    downloadFile(fileId) {
      console.log(fileId);
    },
  },

  computed: {
    ...mapGetters({
      invoicesTotalElements: "invoicing/invoicesTotalElements",
      invoicesTotalPages: "invoicing/invoicesTotalPages",
      invoicingFilter: "invoicing/invoicingFilter",
      isRHProtegido: "user-info/isRHProtegido",
      invoices: "invoicing/invoices",
    }),

    defaultStyleColumns() {
      return this
        .headers
        .filter((header) => !["isIntegrator", "downloads", "actions", "data-table-select", "data-table-expand"]
          .includes(header.value))
        .map((header) => header.value);
    },

    xippPlatformInvoices() {
      return this.getInvoicesToXippPlatform(this.invoices);
    },

    rangePagination() {
      const page = this.invoicingFilter.page;
      const size = this.invoicingFilter.size;
      const total = this.invoicesTotalElements;

      const start = total === 0 ? 0 : page * size + 1;
      const end = Math.min((page + 1) * size, total);

      return `${start}–${end} de ${total}`;
    },

    invoicingTableHeight() {
      const viewportHeight = window.innerHeight;
      const tableHeight = -560 + viewportHeight;
      const isFullScreen = tableHeight <= 1080;
      const hasMoreThanTen = this.xippPlatformInvoices && this.xippPlatformInvoices.length >= 10;

      if (!hasMoreThanTen) return null;
      if (!isFullScreen) return 455;
      return tableHeight < 400 ? 400 : tableHeight;
    },

    headers() {
      const xippPlatformClass = this.$vuetify.breakpoint.mdAndDown ? { class: "platformXippTable" } : {};
      return [
        { value: "financialGroup", sortable: false, class: "col-w-200", cellClass: "col-w-200", ...xippPlatformClass },
        { value: "contract", sortable: false, class: "col-w-250", cellClass: "col-w-250", ...xippPlatformClass },
        { value: "subcontract", sortable: false, class: "col-w-250", cellClass: "col-w-250", ...xippPlatformClass },
        { value: "carrierName", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "competencyDate", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "invoiceType", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "numberLives", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "copayValue", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "premiumValue", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "iofValue", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "replaceFeeValue", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "settlementValue", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "otherAmountsValue", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "bankSlipValue", sortable: false, class: "col-w-200", cellClass: "col-w-200", ...xippPlatformClass },
        { value: "isIntegrator", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "downloads", sortable: false, class: "col-w-200 fixed-column", cellClass: "col-w-200 fixed-column", ...xippPlatformClass, fixed: true },
        { value: "status", sortable: false, class: "col-w-150 fixed-column", cellClass: "col-w-150 fixed-column", ...xippPlatformClass, fixed: true },
        { value: "actions", width: "60px", sortable: false, align: "center", class: "col-w-150 fixed-column", cellClass: "col-w-150 fixed-column", fixed: true },
      ];
    },

    headerFirstLineClass() {
      return this.$vuetify.breakpoint.mdAndDown ? `${this.headerFirstLine.class} platformXippTable` : this.headerFirstLine.class;
    },
  },

  created() {
    this.formatter = new Formatters();
  },

  async mounted() {
    await this.loadKinships();
  },
};
</script>

<style lang="scss">
.fileToDownload {
  text-decoration: none;
  color: #00a09d;
}

.fileToDownload:hover {
  cursor: pointer;
  text-decoration: underline;
}

.invoicingTable .col-w-250 {
  min-width: 250px !important;
  max-width: 250px !important;
}

.invoicingTable .col-w-200 {
  min-width: 200px !important;
  max-width: 200px !important;
}

.invoicingTable .col-w-150 {
  min-width: 150px !important;
  max-width: 150px !important;
}

.invoicingTable {
  .fixed-column {
    position: sticky !important;
    right: 0;
    z-index: 2;
    background: white;

    &:last-child {
      right: 0;
    }

    &:nth-last-child(2) {
      right: 100px;
    }

    &:nth-last-child(3) {
      right: 150px;
    }
  }

  .v-data-table-header {
    .fixed-column {
      background: var(--v-ternary-base) !important;
      z-index: 3;
    }
  }

  .v-data-table__expanded {
    .fixed-column {
      background: white;
    }
  }

  border-radius: 5px !important;
  box-shadow: 0px 2px 6px #1a1f2626 !important;

  >.v-data-table__wrapper {
    border-radius: 5px 5px 0px 0px !important;
    overflow-x: auto !important;

    >table {
      >.v-data-table-header {
        border-radius: 5px 5px 0px 0px !important;
        background-color: var(--v-ternary-base) !important;

        >tr {
          max-height: 90px;
          border-radius: 5px !important;

          >th {
            padding: 0 1% !important;
            background: var(--v-ternary-base) !important;

            >span {
              color: white !important;
            }
          }
        }
      }

      >tbody>tr {
        max-height: 70px;

        >td {
          padding: 0 1% !important;
        }
      }
    }
  }
}

.footerSelectItemsPerPage .v-select__selections {
  >.select__selection {
    margin: 5px 0x 3px 0 !important;
  }

  >input {
    display: none !important;
  }
}

.footerSelectItemsPerPage .v-select__selections {
  display: flex;
  justify-content: center;

  >.v-select__selection.v-select__selection--comma {
    margin: 5px 0px 3px 0 !important;
  }
}

.v-data-table>.v-data-table__wrapper tr.v-data-table__expanded {
  box-shadow: none !important;
}
</style>